import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import git from "../assets/git.png";
import node from "../assets/node.png";
import redux from "../assets/redux.png";
import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

export default {
  email,
  mobile,
  git,
  node,
  redux,
  profile,
  circle,
  logo,
};
